// src/components/FoodConsumptionScore.ts
type P = Record<string, any>;
const n = (v: any) => {
  const x = typeof v === "number" ? v : parseFloat(String(v));
  return Number.isFinite(x) ? Math.max(0, Math.min(7, x)) : 0; // 0..7
};

/** WFP FCS (0..112) */
export default function computeFCS(p: P): number {
  // exact column names from your chartFields
  const staples   = n(p["Number of days consumed staples"]);
  const pulses    = n(p["Number of days consumed pulses"]);
  const dairy     = n(p["Number of days consumed dairy"]);
  const meat      = n(p["Number of days consumed meat"]);
  const fish      = n(p["Number of days consumed fish"]);
  const eggs      = n(p["Number of days consumed eggs"]);

  // animal protein group (cap to 7)
  const animal7   = Math.min(7, meat + fish + eggs);

  // vegetables group (cap to 7)
  const leafy     = n(p["Number of days consumed leafy vegetables"]);
  const vitAVeg   = n(p["Number of days consumed vitamin A vegetables"]);
  const veg7      = Math.min(7, leafy + vitAVeg);

  // fruits group (cap to 7)
  const fruitsA   = n(p["Number of days consumed vitamin A fruits"]);
  const fruitsG   = n(p["Number of days consumed fruits"]); // if you later add a general fruits col
  const fruits7   = Math.min(7, fruitsA + fruitsG); // if you don't have general fruits, keep fruitsG=0

  const sugar     = n(p["Number of days consumed sugar/sweets"]);
  const oil       = n(p["Number of days consumed oils/fats"]);

  // Weights: staples=2, pulses=3, dairy=4, animal protein=4, veg=1, fruit=1, sugar=0.5, oil=0.5
  const score =
    staples * 2 +
    pulses  * 3 +
    dairy   * 4 +
    animal7 * 4 +
    veg7    * 1 +
    fruits7 * 1 +
    sugar   * 0.5 +
    oil     * 0.5;

  return Number.isFinite(score) ? score : 0;
}
